<ng-container *ngIf="isCreateMode() || isUpdateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      [mode]="mode"
      createLabel="Ajouter un établissement"
      [updateLabel]="form.get('establishment')?.value?.label"
    ></base-form-header>

    <mat-dialog-content fxLayout="column">
      <base-form-input
        label="Etablissement"
        type="autocomplete"
        [items$]="establishments$"
        (autocompleteChange)="establishmentAutoCompleteChange($event)"
        displayProperty="label"
        controlName="establishment"
      ></base-form-input>

      <base-form-input
        [maxNumber]="data.building.surface"
        label="Surface Totale (m²)"
        type="number"
        controlName="surface"
      ></base-form-input>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="mode"
        entityLabel="BUILDING"
        [loading]="loading"
        (onCreate)="createItem()"
        (onUpdate)="updateItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isDeleteMode()">
  <form-modal-delete-base
    [label]="data.name"
    [loading]="loading"
    (onClose)="close()"
    (onDelete)="deleteItem()"
  ></form-modal-delete-base>
</ng-container>
